import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";

export const returnsClaimsAnalyticsBreadcrumb = breadcrumbSlot();
export const productDetailsBreadcrumb = breadcrumbSlot();
